export default __webpack_public_path__ + "static/media/flc-mobile-icon.63bce1ba.png";